import React from 'react';

import { PaymentDto, PaymentStatus } from '@alpha/payments-dtos';

import HeaderButtons from './HeaderButtons/HeaderButtons';
import HeaderText from './HeaderText/HeaderText';
import useStyles from './styles';

interface IProps {
  selectedPayment: PaymentDto | undefined;
  viewOnly?: boolean,
  icon?: JSX.Element,
  }

const Header: React.FC<IProps> = ({
  selectedPayment,
  viewOnly,
  icon,
}: IProps) => {
  const styles = useStyles();
  return (
    <div className={styles.container} >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {icon ? icon : null}
        <HeaderText
          selectedPayment={selectedPayment}
        />
      </div>
      {
        !viewOnly
          && (
          <HeaderButtons
            showDownloadButton={
              !(selectedPayment?.status === PaymentStatus.VALIDATED
                || selectedPayment?.status === PaymentStatus.UPLOADED)
          }
            recordId={selectedPayment?.id || '-'} 
          />
          ) 
      }
    </div>
  );
};

export default Header;
